/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Selbstversplichtungserklaerungid2Inputs */



/**

* @param {_Field_Selbstversplichtungserklaerungid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_selbstversplichtungserklaerungid2 = /** @type {((inputs?: _Field_Selbstversplichtungserklaerungid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Selbstversplichtungserklaerungid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Selbstverpflichtungserklärung")
});
export { _field_selbstversplichtungserklaerungid2 as "_field_selbstversplichtungserklaerungID" }